import React, { useState } from "react";
import { Box, Typography, Grid, Button, Link } from "@mui/material";
import JobDescription from "./JobDescription";
import Highlight from "./Highlight";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import MoreInfo from "./MoreInfo";

const RightPanel = () => {
  const [activeSection, setActiveSection] = useState<string>("highlight");
  const jobTitle = useSelector((state:RootState) => state.campaign.jobTitle);
  const companyName = useSelector((state:RootState) => state.campaign.companyName);
  const aboutCompany = useSelector((state:RootState) => state.campaign.aboutCompany);
  const corpLogo = useSelector((state: RootState) => state?.campaign.mediaList.logo);

  const scrollToSection = (id: string) => {
    setActiveSection(id);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <Box
      sx={{
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        borderRadius: "20px",
        border: "1px solid #E7E7EA",
        backgroundColor: "#fff",
      }}
    >
      <Grid xs={12} md={12} lg={12} sx={{ borderBottom: "1px solid #D2D1D6" }}>
        <Grid
          xs={12}
          md={12}
          lg={12}
          sx={{ display: "flex", padding: '12px', alignItems: "center" }}
        >
          <Grid xs={12} md={8} lg={8} sx={{ display: "flex", gap: "4px" }}>
            {corpLogo ? <img src={corpLogo} alt={companyName} style={{width:'50px', height:'50px', borderRadius:'4px'}} /> : null }
            <Grid>
              {jobTitle && (
                 <Typography sx={{ fontSize: "16px", fontWeight: 600 }}>
                  {jobTitle}{" "}
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                     <path fill-rule="evenodd" clip-rule="evenodd" d="M9.5 2C9.5 1.72386 9.72386 1.5 10 1.5H14C14.2761 1.5 14.5 1.72386 14.5 2L14.5 6C14.5 6.27614 14.2761 6.5 14 6.5C13.7239 6.5 13.5 6.27614 13.5 6L13.5 3.20711L9.02022 7.68689C8.82496 7.88215 8.50838 7.88215 8.31311 7.68689C8.11785 7.49162 8.11785 7.17504 8.31311 6.97978L12.7929 2.5H10C9.72386 2.5 9.5 2.27614 9.5 2ZM5.1786 2.83333L6.66667 2.83333C6.94281 2.83333 7.16667 3.05719 7.16667 3.33333C7.16667 3.60948 6.94281 3.83333 6.66667 3.83333H5.2C4.6317 3.83333 4.23554 3.83372 3.92712 3.85892C3.62454 3.88364 3.45069 3.92973 3.31901 3.99682C3.03677 4.14063 2.8073 4.3701 2.66349 4.65235C2.5964 4.78403 2.55031 4.95787 2.52559 5.26045C2.50039 5.56887 2.5 5.96503 2.5 6.53333V10.8C2.5 11.3683 2.50039 11.7645 2.52559 12.0729C2.55031 12.3755 2.5964 12.5493 2.66349 12.681C2.8073 12.9632 3.03677 13.1927 3.31901 13.3365C3.45069 13.4036 3.62454 13.4497 3.92712 13.4744C4.23554 13.4996 4.6317 13.5 5.2 13.5H9.46667C10.035 13.5 10.4311 13.4996 10.7395 13.4744C11.0421 13.4497 11.216 13.4036 11.3477 13.3365C11.6299 13.1927 11.8594 12.9632 12.0032 12.681C12.0703 12.5493 12.1164 12.3755 12.1411 12.0729C12.1663 11.7645 12.1667 11.3683 12.1667 10.8V9.33333C12.1667 9.05719 12.3905 8.83333 12.6667 8.83333C12.9428 8.83333 13.1667 9.05719 13.1667 9.33333V10.8214C13.1667 11.3633 13.1667 11.8004 13.1378 12.1543C13.108 12.5187 13.0451 12.8388 12.8942 13.135C12.6545 13.6054 12.272 13.9878 11.8016 14.2275C11.5055 14.3784 11.1854 14.4413 10.821 14.4711C10.467 14.5 10.03 14.5 9.48808 14.5H5.17858C4.6367 14.5 4.19963 14.5 3.84569 14.4711C3.48126 14.4413 3.16117 14.3784 2.86502 14.2275C2.39462 13.9878 2.01217 13.6054 1.77248 13.135C1.62159 12.8388 1.55868 12.5187 1.52891 12.1543C1.49999 11.8004 1.5 11.3633 1.5 10.8214V6.51193C1.5 5.97004 1.49999 5.53296 1.52891 5.17902C1.55868 4.8146 1.62159 4.4945 1.77248 4.19836C2.01217 3.72795 2.39462 3.3455 2.86502 3.10582C3.16117 2.95492 3.48126 2.89202 3.84569 2.86224C4.19963 2.83332 4.6367 2.83333 5.1786 2.83333Z" fill="#2B244C"/>
                     </svg>
                </Typography>
              )}
                <Typography
                  sx={{ fontSize: "12px", fontWeight: 400, color: "#6E00BE" }}
                >
                  {companyName}
                </Typography>
            </Grid>
          </Grid>
          <Grid xs={12} md={4} lg={4} sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              startIcon={
                <svg
                  width="14"
                  height="11"
                  viewBox="0 0 14 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M12.7905 1.47352L5.15739 4.81382L8.28505 5.6788C8.56685 5.75673 8.7872 5.97665 8.86568 6.2583L9.79332 9.58746L12.7905 1.47352ZM12.7485 0.400342C13.4217 0.105765 14.1189 0.763261 13.8643 1.45253L10.5528 10.4174C10.2727 11.1757 9.18534 11.1311 8.96835 10.3523L7.92767 6.6175L4.43839 5.65252C3.6822 5.44339 3.60767 4.40044 4.32643 4.0859L12.7485 0.400342ZM7.90237 6.52672L7.90246 6.52704L7.90237 6.52672ZM1.83333 1.54436C1.83333 1.26822 2.05719 1.04436 2.33333 1.04436H5.66667C5.94281 1.04436 6.16667 1.26822 6.16667 1.54436C6.16667 1.8205 5.94281 2.04436 5.66667 2.04436H2.33333C2.05719 2.04436 1.83333 1.8205 1.83333 1.54436ZM0.5 5.87769C0.5 5.60155 0.723858 5.37769 1 5.37769H2.66667C2.94281 5.37769 3.16667 5.60155 3.16667 5.87769C3.16667 6.15384 2.94281 6.37769 2.66667 6.37769H1C0.723858 6.37769 0.5 6.15384 0.5 5.87769ZM1.5 9.54436C1.5 9.26822 1.72386 9.04436 2 9.04436H5.66667C5.94281 9.04436 6.16667 9.26822 6.16667 9.54436C6.16667 9.8205 5.94281 10.0444 5.66667 10.0444H2C1.72386 10.0444 1.5 9.8205 1.5 9.54436Z"
                    fill="white"
                  />
                </svg>
              }
              sx={{
                borderRadius: "8px",
                backgroundColor: "#6E00BE",
                color: "#fff",
                fontSize: "14px",
                fontWeight: 400,
                padding: "8px 12px 8px 12px",
                cursor: "default",
                ":hover": {
                  backgroundColor: "#6E00BE",
                  color: "#fff",
                },
                height: 36
              }}
              aria-label="Quick Apply"
            >
              Quick Apply
            </Button>
          </Grid>
        </Grid>
      </Grid>

      <Grid
        container
        spacing={2}
        sx={{
          padding: "8px 0px 8px 0px",
          // alignSelf: "stretch",
          display: "flex",
          flexDirection: "column",
          marginLeft: "0",
          width: "auto"
          // gap: "12px",
        }}
      >
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            padding: "8px 0 8px 0",
            marginBottom: "12px",
            borderBottom: "1px solid #D2D1D6"
          }}
        >
          <Grid item xs={12} md={2} lg={2}>
            <Link
              // href="#"
              variant="body2"
              sx={{
                whiteSpace: "nowrap",
                fontSize: "12px",
                fontWeight: 500,
                textDecoration: "none",
                color: activeSection === "highlight" ? "#6E00BE" : "#777585",
                borderBottom: activeSection === "highlight" ? "2px solid var(--Primary-Purple-0, #6E00BE)" : "0",
                paddingBottom: '8px',
                cursor: "pointer"
              }}
              onClick={() => scrollToSection("highlight")}
            >
              Highlight
            </Link>
          </Grid>
          <Grid item xs={12} md={2.5} lg={2.5}>
            <Link
              variant="body2"
              sx={{
                whiteSpace: "nowrap",
                fontSize: "12px",
                fontWeight: 500,
                textDecoration: "none",
                color: activeSection === "description" ? "#6E00BE" : "#777585",
                borderBottom: activeSection === "description" ? "2px solid var(--Primary-Purple-0, #6E00BE)" : "0",
                paddingBottom: '8px',
                cursor: "pointer"
              }}
              onClick={() => scrollToSection("description")}
            >
              Job Description
            </Link>
          </Grid>
          <Grid item xs={12} md={2} lg={2}>
            <Link
              variant="body2"
              sx={{
                whiteSpace: "nowrap",
                fontSize: "12px",
                fontWeight: 500,
                textDecoration: "none",
                color: activeSection === "recruiterInfo" ? "#6E00BE" : "#777585",
                borderBottom: activeSection === "recruiterInfo" ? "2px solid var(--Primary-Purple-0, #6E00BE)" : '0',
                paddingBottom: '8px',
                cursor: "pointer"
              }}
              onClick={() => scrollToSection("recruiterInfo")}
            >
              More Info
            </Link>
          </Grid>
        </Grid>

        <Grid
          xs={12}
          sx={{
            display: "flex",
            flexDirection: "column",
            overflowY: "auto",
            overflowX: "hidden",
            maxHeight: "630px",
            gap: "16px",
          }}

        >
          <Grid xs={12} md={12} lg={12} sx={{ display: "flex", borderBottom: 1, borderColor: '#F4F4F5', marginTop: '12px', paddingBottom: '12px' }}>
            <Highlight />
          </Grid>
          <Grid xs={12} md={12} lg={12} sx={{ display: "flex", borderBottom: 1, borderColor: '#F4F4F5', marginTop: '12px', paddingBottom: '12px' }}>
            <JobDescription />
          </Grid>
          {/* <Grid xs={12} md={12} lg={12} sx={{ display: "flex", borderBottom:1, borderColor: '#F4F4F5', marginTop: '12px', paddingBottom: '12px' }}>
            <Grid item xs={12} id="moreInfo" sx={{ margin: "0 16px" }}>
              <Typography
                sx={{ fontSize: "14px", fontWeight: 600, lineHeight: "normal", paddingBottom: "16px" }}
              >
                More info
              </Typography>
              <MoreInfo/>
            </Grid>
          </Grid> */}
          <Grid xs={12} md={12} lg={12} sx={{ borderColor: '#F4F4F5' }} id="recruiterInfo">
            <Grid sx={{ margin: '0 16px 16px 16px' }}>
              <div style={{ display: 'flex', justifyContent: "space-between", alignItems: 'center', margin: "0 0 8px 0" }}>
                {companyName ? <Typography sx={{ fontSize: '16px', lineHeight: '24px', fontWeight: '400' }}>
                  About <span style={{ color: '#6E00BE' }}>{companyName}</span>
                </Typography> : null}
                <Button
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "6px 12px 6px 12px",
                    borderRadius: "8px",
                    color: "#6E00BE",
                    fontSize: "14px",
                    fontWeight: 600,
                    border: "1px solid #5D4DA8"
                  }}
                  startIcon={
                    <svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2.00659 0.835938C1.27629 0.835938 0.673258 1.43767 0.673258 2.16797L0.666748 14.1693L6.00008 12.1693L11.3334 14.1693V13.207V2.16927C11.3334 1.44056 10.7288 0.835938 10.0001 0.835938H2.00659ZM2.00659 2.16927H10.0001V12.2448L6.00008 10.7448L2.00138 12.2448L2.00659 2.16927Z" fill="#6E00BE" />
                    </svg>
                  }
                  id="follow"
                  aria-label="Follow Recruiter"
                >
                  Follow
                </Button>
              </div>
              {aboutCompany ? <Typography sx={{ fontSize: '16px', lineHeight: '24px', fontWeight: '400' }}>
                {aboutCompany}
              </Typography> : null}
            </Grid>
            <hr style={{ width: "100%", borderTop: "0px solid rgb(244, 244, 245)" }} />
          </Grid>
          <Grid sx={{marginTop:'-16px'}}>
          <Typography
              sx={{ fontSize: "12px", fontWeight: 400, lineHeight: "18px", color: '#A5A3AE', marginLeft: '16px',display:'inline-flex' }}
            >
              Job ID: 12345678
            </Typography>
            <Grid sx={{ display: 'flex', flexDirection: 'row', gap: '8px', marginLeft: '14px',paddingBottom:'24px',marginTop:"8px" }}>
              <Button
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "8px 12px 8px 12px",
                  borderRadius: "4px",
                  color: "#6E00BE",
                  fontSize: "14px",
                  fontWeight: 600,
                  border: "1px solid #5D4DA8"
                }}
                startIcon={
                  <svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.00659 0.835938C1.27629 0.835938 0.673258 1.43767 0.673258 2.16797L0.666748 14.1693L6.00008 12.1693L11.3334 14.1693V13.207V2.16927C11.3334 1.44056 10.7288 0.835938 10.0001 0.835938H2.00659ZM2.00659 2.16927H10.0001V12.2448L6.00008 10.7448L2.00138 12.2448L2.00659 2.16927Z" fill="#6E00BE" />
                  </svg>
                }
                id="savejob"
                aria-label="Save job"
              >
                Save
              </Button>
              <Button
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "8px 12px 8px 12px",
                  borderRadius: "4px",
                  color: "#6E00BE",
                  fontSize: "14px",
                  fontWeight: 600,
                  border: "1px solid #5D4DA8"
                }}
                startIcon={
                  <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 0.5V1.16667V7.83333V12.5H1.33333V7.83333H6.25521L6.92187 9.16667H12V1.83333H7.74479L7.07813 0.5H0ZM1.33333 1.83333H6.25521L6.92187 3.16667H7.33333H10.6667V7.83333H7.74479L7.07813 6.5H1.33333V1.83333Z" fill="#6E00BE" />
                  </svg>
                }
                id="report"
                aria-label="Report Job"
              >
                Report
              </Button>
            </Grid>
          </Grid>
         
        </Grid>
      </Grid>
    </Box>
  );
};

export default RightPanel;
